export interface CsvColumn<T> {
  header: string;
  accessor: (row: T) => string | number;
}

function escapeCsvCell(value: string | number): string {
  const str = String(value);
  if (str.includes(",") || str.includes('"') || str.includes("\n")) {
    return `"${str.replace(/"/g, '""')}"`;
  }
  return str;
}

/** Pure — builds the CSV text. Split out from exportToCsv so it's testable without mocking the DOM. */
export function buildCsvString<T>(rows: T[], columns: CsvColumn<T>[]): string {
  const headerLine = columns.map((column) => escapeCsvCell(column.header)).join(",");
  const rowLines = rows.map((row) => columns.map((column) => escapeCsvCell(column.accessor(row))).join(","));
  return [headerLine, ...rowLines].join("\r\n");
}

/**
 * Generic column-driven CSV exporter, triggered client-side via a Blob
 * download link. Opens fine in Excel — a deliberate v1 simplification
 * instead of adding an xlsx-generation dependency.
 */
export function exportToCsv<T>(filename: string, rows: T[], columns: CsvColumn<T>[]): void {
  const csv = buildCsvString(rows, columns);
  const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
}
